module.exports = __webpack_public_path__ + "d308073b/img/link-icon.fa09ed66.svg";